module.exports = __webpack_public_path__ + "img/crane.8624841f.png";